import { SwitchAnimation } from "../Animation/Animation.jsx";
import {
  LoadingSpinner,
  LoadingError,
} from "../LoadingElements/LoadingElements.jsx";

export const FetchComponent = ({
  keyAnimation,
  loading,
  error,
  children,
  height,
  maxHeight,
  heightContainer,
}) => {
  return (
    <SwitchAnimation keyAnimation={keyAnimation}>
      {loading ? (
        <div style={{ height: heightContainer }}>
          <LoadingSpinner />
        </div>
      ) : error ? (
        <div style={{ height: heightContainer }}>
          <LoadingError height={height} maxHeight={maxHeight} />
        </div>
      ) : (
        children
      )}
    </SwitchAnimation>
  );
};
